
interface CaseCardProps {
  image: string;
  category?: string;
  title: string;
  date: string;
}

export default function CaseCard({ image, category, title, date }: CaseCardProps) {
  return (
    <div className="bg-[#1a1a1a] rounded-2xl overflow-hidden hover:transform hover:scale-[1.02] transition-all cursor-pointer border border-gray-800 hover:border-gray-700 group">
      <div className="relative w-full h-72">
        <img 
          src={image} 
          alt={title} 
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
      </div>
      <div className="p-4">
        {category && (
          <span className="inline-block bg-blue-600/20 text-blue-400 text-xs px-3 py-1 rounded-full mb-3">
            {category}
          </span>
        )}
        <h3 className="text-sm font-medium text-white mb-2 line-clamp-2 leading-relaxed">
          {title}
        </h3>
        <p className="text-xs text-gray-500">{date}</p>
      </div>
    </div>
  );
}
